import util from '@utils/util';
import globalHeader from '../../../basic/re_header';
import liveContent from './components/pc/liveContent';
import lmClick from '../../../../../mixins/lmClick';
export default {
  name: 'pageLive',
  mixins: [lmClick],
  data: function data() {
    return {};
  },
  props: {},
  components: {
    liveContent: liveContent,
    globalHeader: globalHeader
  },
  created: function created() {
    util.handeError();
  }
};